import React from 'react'
import Svg from './Svg';
import { defaultGrey } from '../../prop-types';

interface IDelete{
  color?: string
  size?: number
}
export default function Delete({color = defaultGrey, size}: IDelete):  any {
  return (
    <Svg
      size={size}
      xmlns={"http://www.w3.org/2000/svg"}
      paths={[
        { fill:"none", d:"M0 0h24v24H0z" },
        { fill: color, d:"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" },
      ]}
    />
  )
}



